"use client";

import Link from "next/link";
import { Action } from "@clover-web-lib-sprout/action";
import SomethingWentWrongImage from "../_icons/somethingWentWrong";
import { clearStorageOnError } from "@/utils/errorUtils";

export default function SomethingWentWrong() {
  const handleClick = () => {
    clearStorageOnError();
    window.location.href = "/";
  };

  return (
    <div className="w-full flex flex-col items-center justify-center h-[60vh]">
      <SomethingWentWrongImage />
      <h2 className="text-[32px] leading-[40px] mt-[22px] mb-[22px]">
        Something went wrong
      </h2>
      <p className="mb-[35px]">Please try again</p>
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        <Action>Try again</Action>
      </div>
    </div>
  );
}
